<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
    <v-container class="ma-0 pa-0" data-html2canvas-ignore>
      <v-row no-gutters class="ma-0 pa-0">
        <v-col class="ma-0 pa-0 text-left ml-8">
          <span
            :key="hover_text"
            class="trade-blue-text font-weight-bold hs8_code mt-0 pt-0"
            >{{ hover_text }}</span
          >
        </v-col>
      </v-row>
    </v-container>
  </div>

  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
  import VuePlotly from '@statnett/vue-plotly';
  import {mapGetters} from 'vuex';
  import {config} from '@/store/config';

  export default {
    name: 'abs_stacked_chart',
    components: {
      VuePlotly,
    },
    props: ['graph_data', 'hover_text'],
    computed: {
      ...mapGetters([
        'get_dsm_result',
        'historyPlotDataTotal',
        'getDsmAppState',
        'app_data',
        'single_product',
        'home_market_code',
      ]),

      plotData: function () {
        // console.log(this.graph_data['data']);
        return this.graph_data['data'].map((v, i) => {
          return {
            ...v,
            line: {color: config.plot_top6_colors[i], width: config.plot_line_width},
          };
        });
      },
      show: function () {
        return true;
      },
      layout: function () {
        return {
          title: {
            text:
              this.graph_data['main_title'] + '<br>' + this.graph_data['secondary_title'],
            font: {
              size: 10,
              color: 'black',
            },
            yref: 'container',
            x: 0.5,
            y: 0.91,
            yanchor: 'bottom',
            pad: {
              b: 10,
            },
          },

          height: '300',

          autosize: true,

          margin: {
            l: 50,
            r: 0,
            b: 55,
            t: 90,
            pad: 2,
          },

          xaxis: {
            tickmode: 'linear',
            automargin: true,
            tickangle: 90,
            tickfont: {
              size: 10,
            },
          },
          yaxis: {
            title: '',
            rangemode: 'tozero',

            tickfont: {
              size: 10,
            },
          },
          legend: {
            font: {size: 9},
            automargin: true,
          },
          annotations: [
            {
              x: '0',
              y: '1.15',
              xref: 'paper',
              yref: 'paper',
              xanchor: 'left',
              yanchor: 'top',
              text: this.graph_data['line_char_unit'],

              showarrow: false,
            },
            {
              xref: 'paper',
              yref: 'paper',
              x: -0.02,
              y: -0.23,
              xanchor: 'left',
              yanchor: 'top',
              text: this.graph_data['source'],
              showarrow: false,
              font: {
                family: 'Arial',
                size: 8.5,
                color: 'rgb(150,150,150)',
              },
            },
          ],
        };
      },
    },
    methods: {},
    data: function () {
      return {
        options: {
          responsive: true,
          displayModeBar: false,
        },
      };
    },
  };
</script>

<style scoped>
  .hs8_code {
    display: block;
    max-height: 60px;
    min-height: 60px;
    height: 60px;
    padding: 10px;
    font-size: 11px;
    line-height: normal;
    max-width: 100%;
    font-weight: lighter;
  }
</style>
